import React, { useEffect } from "react";
import _ from "lodash";
const CalendlyBlock = (props) => {
    const calendlyId = _.get(props, "settings.meeting_ID", "");

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://assets.calendly.com/assets/external/widget.js';
        script.async = true;

        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);

    return (
        <div className="col-sm-12">
            <div className="slideInUp wow ">
                <div className="meetingid">
                    <div className="calendly-inline-widget pt-0" data-url={`${calendlyId}?hide_gdpr_banner=1`} style={{ width: '100%', height: '700px' }}>
                    </div>
                </div>
            </div>
        </div >
    );

};

export default CalendlyBlock;
